<template>
  <div>
    <b-row>
      <b-col md="12" class="my-1">
        <h3 class="text-themecolor">Releases</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-alert v-if="latestRelease" variant="success" :show="latestRelease.build != ''">
          Release {{ latestRelease.build }} {{$t('releases.isbeschikbaarklik')}} <strong style="cursor:pointer"><u @click.stop="createNewRelease()">{{$t('releases.hier')}}</u></strong> {{$t('releases.omdezeaantemaken')}}
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <div class="card">
          <div class="card-body">
            <!-- User Interface controls -->
            <b-row>
              <b-col md="12" class="my-1">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="searchFilter" :placeholder="$t('datatables.zoeken')" ref='search'/>
                        <b-input-group-append>
                            <b-form-select v-model="statusFilter" style="width:300px;">
                                <option selected="selected" value="-1">{{$t('releases.allestatussen')}}</option>
                                <option value="1">{{$t('releases.actief')}}</option>
                                <option value="0">{{$t('releases.inactief')}}</option>
                            </b-form-select>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- User Interface controls -->
            
            <!-- Main table element -->
            <b-row>
              <b-col md="12">
                <b-table show-empty
                         :empty-text="getEmptyText(count)"
                         stacked="md"
                         class="table-hover"
                         :items="releases"
                         :fields="fields"
                         :current-page="currentPage"
                         :per-page="perPage"
                         :filter="filter"
                         :busy="count == -1"
                         @filtered="onFiltered"
                         @row-clicked="onRowClicked">
                  <template v-slot:cell(active)="data">{{data.item.active ? $t('releases.actief') : $t('releases.inactief')}}</template>
                  <template v-slot:cell(createdAt)="data">{{data.item.createdAt | datetime }}</template>
                  <template v-slot:cell(companies)="data">{{data.item.assignedCompanies.length}} / {{data.item.totalCompanyCount}} </template>
                  <template v-slot:cell(users)="data">{{data.item.assignedUsers.length}} / {{data.item.totalUserCount}}</template>
                  <template v-slot:table-busy>
                    <PreLoader/>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <!-- Main table element -->
            
            <!-- Pagination controls -->
            <b-row>
              <b-col md="12" lg="5">
                <b-form-group label-cols :label="$t('datatables.perpagina')">
                  <b-form-select :options="pageOptions" v-model="perPage"/>
                </b-form-group>
              </b-col>
              <b-col md="12" lg="7">
                <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right"/>
              </b-col>
            </b-row>
            <!-- Pagination controls -->
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
"use strict";
//Import store
import { mapGetters, mapActions } from 'vuex';
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

import Command from "./command";

export default {
    name: `releases-index`,
    components: {PreLoader},
    data() {
      return {
        latestRelease: null,
        currentPage: 1,
        perPage: 50,
        pageOptions: [50, 100, 200],
        filter: null,
        count: -1,
        statusFilter: '-1',
        searchFilter: ''
      };
    },
    computed: {
      fields() { 
        return [
          {key: 'name', label: this.$i18n.t('datatables.naam'), sortable: true},
          {key: 'version', label: this.$i18n.t('datatables.versie'), sortable: true},
          {key: 'build', label: 'Build', sortable: true},
          {key: 'active', label: this.$i18n.t('datatables.actief'), sortable: true},
          {key: 'createdAt', label: this.$i18n.t('datatables.aangemaaktop'), sortable: true},
          {key: 'companies', label: this.$i18n.t('datatables.bedrijven'), sortable: false},
          {key: 'users', label: this.$i18n.t('datatables.gebruikers'), sortable: false}
        ]
      },
      ...mapGetters('fm', ['releases']),
      sortOptions() {
        return this.fields.filter(f => f.sortable).map(f => {
          return {text: f.label, value: f.key};
        });
      },
    },
    methods: {
      ...mapActions('fm',['all','create','search']),
      createNewRelease() {
        const vm = this;
        vm.$swal ({
            title: `Release aanmaken`,
            text: `Weet u zeker dat u deze release wilt aanmaken?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#398bf7",
            confirmButtonText: "Ja, aanmaken",
            cancelButtonText: "Nee, annuleren"
        }).then((result) => {
            if (result.value) {
              vm.create({ 
                resource: 'releases', 
                params: new Command(vm.latestRelease)
              })
              .then((release) => { 
                vm.$router.push({ name: `releases:detail`, params: { releaseId: release.id } }); 
              });
            }
        });
        
      },
      onFiltered(filteredItems) {
        this.count = filteredItems.length;
        this.currentPage = 1;
      },
      onRowClicked(item) {
        this.$router.push({name: `releases:detail`, params: {releaseId: item.id}});
      },
      getEmptyText,
    },
    created() {
      var vm = this;
      vm.all({
        resource: 'releases'
      })
      .then((data) => {
        vm.count = data.result.length;
      });

      vm.search(`releases/new-devops`)
      .then((release) => {
        vm.latestRelease = release; 
      })
      .catch(() => { })
    }
};
</script>
